module.exports = __webpack_public_path__ + "media/blast-hit-echo.3d392e86.wav";